import { useQuery } from '@tanstack/react-query';
import { companyApi } from '../companyApi';
import { QueryKey } from '@shared/config';

export const useGetCompany = (id: string) => {
  return useQuery({
    queryKey: [QueryKey.GET_COMPANY, id],
    queryFn: () => companyApi.getCompany(id),
  });
};
